import { Button } from "react-bootstrap";

export const ActionButton = ({ className, variant, icon, label, onClick, disabled, ...props }) => (
    <Button className={className} variant={variant} onClick={onClick} disabled={disabled} {...props}>
        <div className='d-flex align-items-center justify-content-center gap-2'>
            {icon}
            <span>{label}</span>
        </div>
    </Button>
);